// extracted by mini-css-extract-plugin
module.exports = {"fileList":"Details_fileList__2udnh","dialog":"Details_dialog__3xUi9"};